import { Injectable } from "@angular/core";
import { BroadcastService, MsalService } from "@azure/msal-angular";

@Injectable()
export class AuthenticationService {
  constructor(
    private _broadcastService: BroadcastService,
    private _msalService: MsalService
  ) {}

  login() {
    this.msalService.loginRedirect();
  }

  logout() {
    this.msalService.logout();
  }

  get msalService(): MsalService {
    return this._msalService;
  }

  get broadcastService(): BroadcastService {
    return this._broadcastService;
  }
}
